<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" :width="size" :height="size">
    <title>{{ title }}</title>
    <circle r="10" cx="10" cy="10"></circle>
  </svg>
</template>

<script>
export default {
  name: "SkeletonCircle",
  props: {
    size: {
      type: Number,
      default: 20,
    },
    radius: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
      default: 'Chargement...',
    },
  },
}
</script>

<style scoped lang="scss">
circle {
  fill: url(#loading); //whitesmoke;
}
</style>
